import { TrimBimExportArgs } from '../../api';

export class CacheDisplaySetting {
  static readonly type = '[DisplaySettings] CacheDisplaySetting';
  constructor(
    public readonly alignmentId: string,
    public readonly settings: TrimBimExportArgs,
  ) {}
}
